import * as React from 'react';
import { Card, Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../Translations';

const LoadingState: React.FC = () => {
  return (
    <Card
      className="w-full pt-6 pr-6 pb-6 pl-6"
      radius="lg"
      data-intercom-target="ai-summary-loading"
    >
      <div className="flex items-center space-x-3">
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-teal-600"></div>
        <Typography variant="bodyMedium" color="dark">
          <T kind="Generating AI Action Plan Impact summary..." />
        </Typography>
      </div>
    </Card>
  );
};

export default LoadingState;
